var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('topNavigation',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPath != 'Vuepdf'),expression:"isPath != 'Vuepdf'"}],staticClass:"topNavigations",attrs:{"addNavListLeft":[
			{
				name: '综合版',
				toLink: 'https://www.drcnet.com.cn/',
				color: '#0065cc',
				fontWeight: 600,
			},
			{
				name: '教育版',
				toLink: 'https://edu.drcnet.com.cn/',
				color: '#0065cc',
				fontWeight: 600,
			},
			{
				name: '党政版',
				toLink: 'http://government.drcnet.com.cn/',
				color: '#0065cc',
				fontWeight: 600,
			} ],"deleteSort":[1, 2, 3],"defalutSort":[4, 5, 6, 3],"alginRight":true},scopedSlots:_vm._u([{key:"nav-top-content-isMobile-bottom",fn:function(){return [_c('homeNavIsMoblie',{staticStyle:{"width":"310px"}})]},proxy:true}])}),_c('appMain')],1)}
var staticRenderFns = []

export { render, staticRenderFns }